import * as React from "react";
import { useEffect, useRef } from "react";
import "./vorgangDetail.css";

/**
 * Textfeld für „Beschreibung/Notiz", das mit dem Inhalt MITWÄCHST
 * (Detail-Remake). Speichern übernimmt die Seite via `onBlurSave`
 * (Auto-Save-Konzept: Fokus verlassen = gespeichert).
 */
type Props = {
    value: string;
    onChange: (next: string) => void;
    onBlurSave?: (value: string) => void;
    placeholder?: string;
    readOnly?: boolean;
    minRows?: number;
    className?: string;
};

export const AutoGrowTextarea: React.FC<Props> = ({
    value,
    onChange,
    onBlurSave,
    placeholder,
    readOnly = false,
    minRows = 2,
    className,
}) => {
    const ref = useRef<HTMLTextAreaElement | null>(null);

    const resize = () => {
        const el = ref.current;
        if (!el) return;
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
    };

    useEffect(resize, [value]);

    return (
        <textarea
            ref={ref}
            className={`vgd-textarea ${className ?? ""}`}
            rows={minRows}
            value={value}
            placeholder={placeholder}
            readOnly={readOnly}
            onChange={(e) => onChange(e.target.value)}
            onBlur={() => onBlurSave?.(value)}
        />
    );
};
